import React from 'react';
import { Badge } from '@/components/ui/badge';

type LastRun = {
  id: string;
  createdAt: string;
  swingId?: string;
  topTags: string[];
};

export function LastRunCard({ data }: { data: LastRun | null }): JSX.Element {
  if (!data) {
    return <div className="text-sm text-muted-foreground">No data yet</div>;
  }

  return (
    <div className="space-y-3">
      <div>
        <div className="font-medium">Run ID: {data.id}</div>
        <div className="text-sm text-muted-foreground">
          {new Date(data.createdAt).toLocaleString()}
        </div>
      </div>
      
      <div>
        <div className="text-sm font-medium mb-2">Focus Areas:</div>
        {data.topTags.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {data.topTags.map(tag => (
              <Badge
                key={tag}
                variant="secondary"
                className="capitalize text-xs"
                data-testid={`tag-${tag}`}
              >
                {tag.replace(/_/g, ' ')}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-sm text-muted-foreground">No tags</div>
        )}
      </div>
    </div>
  );
}

export default LastRunCard;
